export default __webpack_public_path__ + "bd2d94bc217f99bb377c2f330e0e04db.ttf";